import { render, staticRenderFns } from "./Gameconsole.vue?vue&type=template&id=483bb17a&"
import script from "./Gameconsole.vue?vue&type=script&lang=js&"
export * from "./Gameconsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports